import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import KioskFooter from '@components/kioskFooter';
import Modal from '@components/common/Modal';
import styles from './kioskFooter.module.scss';
import { callServer, setIsAssisstance } from '@reducers/checks';
import {
  checkVoid, clearCart, removeSeat, removePaymentCheck, enableStartOverBtn,
  setCategoryHeight
} from '@reducers/orders';
import {
  clearAuthResponse
} from '@reducers/payment';
import { APP_CONFIG, SUCCESS_MESSAGE } from '@constants';
import EventEmitter from '@utility/eventSubscribers';
import { setNotification } from '@reducers/notification';
import { flowType } from '@utility/userInfo';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { getObjectValue } from '../../utility/utills';

const kioskFooter = (props) => {

  // Props Destructuring

  const {deviceInfo, setCategoryHeight, check, callServer, setNotification, userInfo, checkVoid, clearCart, removeSeat, clearAuthResponse, removePaymentCheck,
  setIsAssisstance, isHeight, isAssisstanceCalled, startOverBtn } = props;

  // State Management

  const [isStartOver, setIsStartOver] = useState(false);
  const [isNeedAssistance, setIsNeedAssistance] = useState(false);
  const enableRequestAssistance = getObjectValue(() => deviceInfo.deviceGroup.kioskSettings.enableRequestAssistance, false);
  const enableAccessibility = getObjectValue(() => deviceInfo.deviceGroup.kioskSettings.enableAccessibility, false);

  // React Hooks

  useEffect(() => {
    if (window.ReactNativeWebView) {
      EventEmitter.getViewHeight((data) => {
        setCategoryHeight(data.height !== 100);
      });
    }
  }, []);

  useEffect(() => {
    if (isStartOver) {
      setIsStartOver(!isStartOver);
    }
    if (isNeedAssistance) {
      setIsNeedAssistance(!isNeedAssistance);
    }
  }, [check?.open]);

  // Methods

  const callserver = () => {
    const dataToSend = {
      deviceId: deviceInfo.deviceId,
      storeId: deviceInfo.storeId,
      deviceName: deviceInfo.deviceName,
      checkHeaderId: (check && check.id) || null
    };
    callServer(dataToSend).then(() => {
      setIsNeedAssistance(!isNeedAssistance);
    }).catch((err) => {
      setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const postEvent = () => {
    if (window.ReactNativeWebView) {
      EventEmitter.postEnableResizeView(false);
      EventEmitter.getViewHeight((data) => {
        if (data.height === 100) {
          setCategoryHeight(true);
          EventEmitter.postSetViewHeight(50);
        } else {
          setCategoryHeight(false);
          EventEmitter.postSetViewHeight(100);
        }
      });
    }
  };

  const startOver = () => {
    setIsStartOver(!isStartOver);
  };

  const callVoid = () => {
    const dataToSend = {
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      storeId: deviceInfo.storeId,
      checkHeaderId: check.id,
      deviceId: deviceInfo.deviceId,
    };
    checkVoid(dataToSend);
    clearCart();
    removeSeat();
    clearAuthResponse();
    removePaymentCheck();
    props.history.replace({
      pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/landing`,
    });
  };

  const goToLandingPage = () => {
    window.sessionStorage.removeItem('screenId');
    setIsAssisstance(false);
    if (check) {
      callVoid();
    } else {
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/landing`);
    }
  };

  // HTML CSS Code

  return (
    <>
      <KioskFooter
        {...props}
        startOver={startOver}
        postEvent={postEvent}
        callserver={callserver}
        isHeight={isHeight}
        enableRequestAssistance={enableRequestAssistance}
        enableAccessibility={enableAccessibility}
        isAssisstanceCalled={isAssisstanceCalled}
        startOverBtn={startOverBtn}
      />
      {isStartOver && (
      <Modal
        isOpen={isStartOver}
        isModalCenter
        loading={props.loading}
        customClass2={styles.maxWidth}
      >
        <div className="p-2 justify-content-center align-items-center text-center">
          <div className="col-12 fs-24 fw-600 text-center px-0 py-2">
            {CUSTOM_MESSAGES().RESTART_ORDER}
          </div>
          <div className="col-12 row mx-0 px-0 py-2 justify-content-center align-items-center">
            <div className="col-6 px-1">
              <button className="w-100 btn btn100 btn-secondary od-btn-secondary fs-14" type="button" onClick={() => { setIsStartOver(!isStartOver); }}>
                <div className="fs-30">{LABEL().KIOSK_NO}</div>
              </button>
            </div>
            <div className="col-6 px-1">
              <button className="w-100 btn btn100 btn-primary btn-ripple od-btn-primary fs-14" type="button" onClick={() => { props.enableStartOverBtn(false); setIsStartOver(!isStartOver); goToLandingPage(); }}>
                <div className="fs-30">{LABEL().KIOSK_YES}</div>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      )}
      {isNeedAssistance && (
      <Modal
        isOpen={isNeedAssistance}
        isModalCenter
        loading={props.loading}
        customClass2={styles.maxWidth}
      >
        <div className="p-2 justify-content-center align-items-center text-center">
          <div className="col-12 fs-18 fw-600 text-center px-0 py-2">
            {SUCCESS_MESSAGE.SERVER_CALL}
          </div>
          <div className="col-12 row mx-0 px-0 py-2 justify-content-center align-items-center">
            <button className="w-100 btn btn100 btn-primary btn-ripple od-btn-primary fs-14" type="button" onClick={() => { setIsNeedAssistance(!isNeedAssistance); }}>
              <div className="fs-30">{LABEL().KIOSK_CLOSE}</div>
            </button>
          </div>
        </div>
      </Modal>
      )}
    </>
  );
};

// Redux Part

const mapStateToProps = ({
  oauth, orders, checks
}) => ({
  loading: oauth.loading,
  deviceInfo: oauth.deviceInformation,
  auth: oauth.authInfo,
  isAssisstanceCalled: checks.isAssisstanceCalled,
  userInfo: oauth.loggedInUserData,
  startOverBtn: orders.startOverBtn,
  check: orders.seats,
  isFooter: orders.isFooter,
  isHeight: orders.isHeight,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  callServer,
  setNotification,
  checkVoid,
  setCategoryHeight,
  setIsAssisstance,
  clearCart,
  removeSeat,
  clearAuthResponse,
  removePaymentCheck,
  enableStartOverBtn
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(kioskFooter);
